import { createTheme } from './baseTheme';

export const lightTheme = createTheme({});
